import { locationNameMap, serviceNameMap } from "@/config/namingMap";

export function formatBreadcrumbLabel(segment: string): string {
  const key = segment.toLowerCase();

  if (locationNameMap[key]) return locationNameMap[key];
  if (serviceNameMap[key]) return serviceNameMap[key];

  return segment
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function getBreadcrumbs(pathname: string) {
  const parts = pathname.split("/").filter(Boolean);
  let url = "";
  return parts.map((segment) => {
    url += "/" + segment;
    return {
      label: formatBreadcrumbLabel(segment),
      url
    };
  });
}
